/** @module CollectionBook/_SalesCollectionStateMixin */
define([
	"dojo/_base/declare",
	"csi/heading/stateColorResolver",
], function(declare,stateColorResolver) {

	const AVAILABLE_TO_SELL = "SMState:AvailableToSell";
	const RELEASE_TO_CUSTOMERS = "MCState:ReleaseToCustomers";
	const RELEASE_TO_MARKETS = "MCState:ReleaseToMarkets";
	const DRAFT = "MCState:Draft";
	const MC_NOT_AVAILABLE = "MCState:NotAvailable";
	
	return declare(null, {
		
		/**
		 * Get the css by given context
		 * @param {Context} ctx
		 * @return {string}
		 */
		getSalesStateCss: function(ctx) {
			const scNode = ctx.getNode();
			const mcNode = ctx.cache.getNode(scNode.MasterCollection || scNode.MasterLook || scNode.MasterProduct || scNode.MasterColor);
			
			const scState = scNode.State;
			const mcState = mcNode && mcNode.State;
			
			let css = stateColorResolver.getStateCss(scNode);
			
			if (!css) {
				if (scState === AVAILABLE_TO_SELL) {
					css = "csi-state ";
					if (!mcNode || mcState === RELEASE_TO_CUSTOMERS) {
						css += "csi-state-sc-availabletosell-green";
					} else if (mcState === RELEASE_TO_MARKETS || mcState === DRAFT) {
						css += "csi-state-sc-availabletosell-blue";
					} else if (mcState === MC_NOT_AVAILABLE) {
						css += "csi-state-sc-closed";
					}
				}
			}
			
			return css;
		}
	});
});